import { useState } from 'react'
import { useUltimosLotes } from '../../../api/queries/loteDeAnalise'
import { dataHora } from '../../../lib/datas'
import { TEXTOS } from '../../../lib/glossario'
import { competenciaPorExtenso } from '../../chamados/competencia'
import { AndamentoDoLote } from './AndamentoDoLote'
import { PreviaDoLote } from './PreviaDoLote'

/**
 * Analisar os chamados de uma competência inteira.
 *
 * **Não é a varredura apagada na rc.4.** O sujeito é congelado no pedido e nunca reconsultado, o
 * lote acaba, nenhum cron o cria, troca do texto de análise não o repete, e há um de cada vez no
 * sistema inteiro. Aquela varredura selecionava 412 chamados por conta própria e queimava o backlog
 * em menos de um dia.
 *
 * **É de ADMIN por consequência, e não por hierarquia:** a confirmação mostra a estimativa em reais,
 * e reais não aparecem em tela de fiscalização (V31). O botão de um chamado por vez continua sendo
 * do fiscal.
 *
 * @returns a tela do lote
 */
export function PaginaLoteDeAnalise() {
  const t = TEXTOS.loteDeAnalise
  const [competencia, setCompetencia] = useState('')
  const { data: lotes } = useUltimosLotes()

  return (
    <div className="space-y-5">
      <header>
        <h1 className="titulo-da-pagina">{t.titulo}</h1>
        <p className="mt-1 max-w-prose text-sm text-slate-600">{t.ajuda}</p>
      </header>

      <AndamentoDoLote />
      <PreviaDoLote competencia={competencia} aoMudarCompetencia={setCompetencia} />

      {lotes && lotes.length > 0 && (
        <section className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
          <h2 className="text-base font-semibold text-slate-900">{t.andamento.historico}</h2>
          <ul className="mt-3 space-y-3">
            {lotes.map((lote) => (
              <li key={lote.id} className="rounded-lg border border-slate-100 bg-slate-50/60 p-3 text-sm">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <span className="font-medium text-slate-900">
                    {competenciaPorExtenso(lote.competencia)} — {lote.itensNoPedido} chamados
                  </span>
                  {/* Instante, e não data pura: um lote pedido às 22h de 27/08 aparecia como 28/08. */}
                  <span className="text-xs text-slate-500">{dataHora(lote.solicitadoEm)}</span>
                </div>
                <p className="mt-1 text-xs text-slate-600">
                  {lote.justificativa}
                  {lote.solicitadoPorNome ? ` — ${lote.solicitadoPorNome}` : ''}
                </p>
                <p className="mt-1 text-xs text-slate-700">{t.situacaoDoLote[lote.situacao]}</p>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}
